var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8281 4.22896L4.22846 10.8286C3.96812 11.0889 3.96812 11.5111 4.22846 11.7714C4.48882 12.0317 4.91092 12.0317 5.17128 11.7714L11.7709 5.17176C12.0313 4.91141 12.0313 4.4893 11.7709 4.22896C11.5106 3.9686 11.0885 3.9686 10.8281 4.22896Z",
    fill: "#FF2640"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7709 10.8286L5.17127 4.22895C4.91092 3.9686 4.48881 3.9686 4.22847 4.22895C3.96811 4.4893 3.96811 4.91141 4.22847 5.17176L10.8281 11.7714C11.0884 12.0318 11.5106 12.0318 11.7709 11.7714C12.0313 11.5111 12.0313 11.089 11.7709 10.8286Z",
    fill: "#FF2640"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close-red.49ee1c0bfb86efeee900a059534b5b7c.svg";
export { ForwardRef as ReactComponent };